import _ from 'underscore';
import ActionTypeAdapter from '@bingads-webui-campaign-legacy/adextension-actionlink/view/action-type-adapter';
import LanguageAdapter from '@bingads-webui-campaign-legacy/adextension-actionlink/view/language-adapter';
import SharedEditorView from '@bingads-webui-campaign-legacy/adextension-shared/view/extension-editor';
import config from '@bingads-webui-component-legacy/config/index';
import UrlOptionsV2 from '@bingads-webui-component-legacy/upgraded-url/view/urlOptionsV2';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextensions');
const schema = window.globalLegacySchema.get('ActionAdExtension');

const permissions = config.get('permissions');
const {
  IsFinalURLSuffixPhase4Enabled,
  IsCustomParameterCountIncreasePhase3Enabled,
  IsDomesticSimplifiedChineseEnabled,
} = permissions;

export default class View extends SharedEditorView {
  initialize(options) {
    const fields = [
      {
        property: 'Language',
        control: LanguageAdapter,
      },
      {
        property: 'ActionType',
        control: ActionTypeAdapter,
      }, 'FinalUrls', 'FinalMobileUrls',

      ...IsFinalURLSuffixPhase4Enabled || IsCustomParameterCountIncreasePhase3Enabled ?
        [] : [
          {
            type: 'collapse',
            text: i18n.get('ActionUrlOptions_AdvancedSettings_ExpanderLabel'),
            fields: ['TrackingUrlTemplate', 'UrlCustomParameters'],
          },
        ],
    ];

    if (IsFinalURLSuffixPhase4Enabled || IsCustomParameterCountIncreasePhase3Enabled) {
      const {
        extension,
        placeholderEnabled,
        isForVNext,
        campaignId,
        adgroupId: adGroupId,
      } = options;

      this.campaignId = campaignId;
      this.adGroupId = adGroupId;

      const trackingTemplate = (extension && extension.TrackingUrlTemplate) || undefined;
      const finalUrlSuffix = (extension && extension.FinalUrlSuffix) || undefined;
      const customParameters = (extension && extension.UrlCustomParameters) || undefined;

      this.urlOptions = new UrlOptionsV2({
        entityType: schema.name,

        trackingTemplate,
        finalUrlSuffix,
        customParameters,

        placeholderEnabled,
        showUurlTestTool: false,
        isForVNext,
      });
    }

    let opt = _.defaults(options, {
      schema,
      fields,
    });

    const language = IsDomesticSimplifiedChineseEnabled ? 'SimplifiedChinese' : 'English';

    opt.extension = opt.extension || {
      Language: language,
    };

    super.initialize(opt);
  }

  render() {
    super.render();

    if (this.urlOptions) {
      this.$('.extension-editor__extra').empty().append(this.urlOptions.render().el);
    }

    return this;
  }

  remove() {
    if (this.urlOptions) {
      this.urlOptions.remove();
      this.urlOptions = null;
    }

    super.remove();
  }

  currentModel() {
    const model = super.currentModel();

    if (this.urlOptions) {
      _.extend(model, this.urlOptions.toObject());
    }

    return model;
  }
}
